export const WEB = 1;
export const APP = 2;